import styled, { css } from 'styled-components';

// Styled Components
import {
  Tr,
  TableContainer,
  FiltersContainer,
  SubContainerFilters,
  Td,
  DropDownInputStyled,
  ContainerButtons,
  Container,
} from '../components/MainStyledComponents';

// Types
import { ArrowBottomStyledProps, ShowFiltersButtonProps } from './types';
import { columnNames } from '../components/types';

// Icons
import { ArrowBottom } from '../../../../assets/icons/ArrowBottom';
import { ContainersLoadingProps } from '../InputRadioArrowTable/types';
import { Typography } from '../../Typography';

export const ContainerStyled = styled(Container)`
  position: relative;
`;

export const TableContainerStyled = styled(
  TableContainer
)<ContainersLoadingProps>`
  padding: ${({ theme }) => theme.spaces.m}rem 0;
  overflow-x: auto;
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
`;

export const FiltersWithLoadingStyled = styled(
  FiltersContainer
)<ContainersLoadingProps>`
  padding: ${({ theme }) => theme.spaces.xl}rem;
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spaces.m}rem;
  }
`;

export const ContainerLoader = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  z-index: 1;
`;

export const CampaignSearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xxxs}rem;
  width: 100%;
  max-width: 40rem;
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    max-width: 100%;
  }
`;

export const SubContainerHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ShowFiltersButton = styled.button<ShowFiltersButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  height: 2.3rem;
  border-radius: 0.3rem;
  transition: background 300ms;
  background: ${(props) => (props.isBlack ? props.theme.colors.black : props.theme.colors.garnet)};
`;

export const ArrowBottomStyled = styled(ArrowBottom)<ArrowBottomStyledProps>`
  transition: transform 300ms;
  transform: ${(props) => (props.isRotate ? null : 'rotate(-90deg)')};
  width: 1rem;
  height: 1rem;
  path {
    fill: white;
  }
`;

export const SubContainerFiltersStyled = styled(SubContainerFilters)``;

export const StyledTypography = styled(Typography)`
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.XS};
  }
`;

export const TdStyled = styled(Td)`
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    text-overflow: ellipsis;

    ${(props) =>
      props.column === columnNames.capitol.id && {
        maxWidth: '11.3rem',
      }}
    ${(props) =>
      props.column === columnNames.pkEnd.id && {
        maxWidth: '10rem',
      }}
      ${(props) =>
      props.column === columnNames.pkInit.id && {
        maxWidth: '10rem',
      }}
  }
`;

export const TrStyled = styled(Tr)`
  background-color: ${(props) => props.checked && props.theme.colors.lightRed};
  ${({ indeterminate, checked }) =>
    css`
      Td {
        ${!indeterminate && {
          opacity: 0.2,
        }}
        ${checked && {
          opacity: 1,
        }}
      }
    `}
`;

export const DropDownInputStyledBig = styled(DropDownInputStyled)`
  @media (max-width: ${({ theme }) => theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    max-width: 21rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    max-width: 16rem;
  }
`;

export const ContainerButtonStyled = styled(ContainerButtons)``;
